export interface PlanCredits { 
    name: string;
    description: Array<string>;
    credits: number | null;
}

export const subscriptionPlanCredits: PlanCredits[] = [
    {
        name: 'Basic',
        description: ['1000 gems', 'Real-Time Live Chat', 'Access to All Language Models', 'Unlimited Character Creation', 'Advanced Image Generation'],
        credits: 1000
    },
    {
        name: 'Premium',
        description: ['3200 gems', 'Real-Time Live Chat', 'Access to All Language Models', 'Unlimited Character Creation', 'Advanced Image Generation'],
        credits: 3200
    },
    {
        name: '320 credit',
        description: ['320 gems', 'One-time purchase'],
        credits: 320
    },
    {
        name: '720 credit',
        description: ['720 gems', 'One-time purchase'],
        credits: 720
    },
    {
        name: '2000 credit',
        description: ['2000 gems', 'One-time purchase'],
        credits: 2000
    },
    {
        name: '5000 credit',
        description: ['5000 gems', 'One-time purchase'],
        credits: 5000
    }
]